module.exports = __webpack_public_path__ + "img/sequence-miyashita-park@2x.b68bb554.jpg";